import { render, staticRenderFns } from "./MoleculeEditionProductPricesAndPlansVidroop.vue?vue&type=template&id=71cd3ddd&"
import script from "./MoleculeEditionProductPricesAndPlansVidroop.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionProductPricesAndPlansVidroop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports